import JsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { formatDateFromDB } from '../../../../../utils/FormatDate';

export const TIP_IZVESTAJA = { RN: 'RN', PUR: 'PUR' };
export const JEZIK_IZVESTAJA = { SRB: 'SRB', ENG: 'ENG' };

const MARGINA = 14;
const FONT = 'Roboto';
const LOGO_SIRINA = 48;
const LOGO_VISINA = (LOGO_SIRINA * 227) / 916;

const BOJE = {
  narandzasta: [240, 102, 10],
  narandzastaTamna: [191, 78, 0],
  narandzastaSvetla: [254, 237, 224],
  tamna: [33, 37, 41],
  siva: [120, 120, 120],
  linija: [222, 222, 222],
  pozadina: [247, 247, 247],
  zelena: [46, 125, 50],
  crvena: [198, 40, 40],
};

export const PREVODI = {
  SRB: {
    lokal: 'sr-RS',
    da: 'DA',
    ne: 'NE',
    radniNalog: 'Radni nalog',
    pustanjeURad: 'Puštanje u rad',
    datumIzvestaja: 'Datum izveštaja',
    strana: 'Strana',
    nemaPodataka: 'Nema podataka.',
    ukupno: 'Ukupno',
    brojNaloga: 'Broj naloga',
    datum: 'Datum',
    status: 'Status',
    kupac: 'Kupac',
    adresa: 'Adresa',
    robotAlat: 'Robot/Alat',
    serijskiBroj: 'Serijski broj',
    podprojekat: 'Podprojekat',
    brojZahteva: 'Broj zahteva',
    nazivZahteva: 'Naziv zahteva',
    datumZavrsetka: 'Datum završetka',
    zavrsen: 'Završen',
    naplacujeSe: 'Naplaćuje se',
    teren: 'Teren',
    obuka: 'Obuka',
    opisProblema: 'Opis problema',
    opisRadova: 'Opis radova',
    napomena: 'Napomena',
    dodeljeniZaposleni: 'Dodeljeni zaposleni',
    zaposleni: 'Zaposleni',
    komisija: 'Komisija',
    izvrseneUsluge: 'Izvršene usluge',
    nazivUsluge: 'Naziv usluge',
    jm: 'JM',
    kolicina: 'Količina',
    praznik: 'Praznik',
    brutoCenaPrekovremeno: 'Bruto cena prekovremeno',
    brutoCenaZaposlenog: 'Bruto cena zaposlenog',
    cenaPremaKlijentu: 'Cena prema klijentu',
    ukupnoTrosak: 'Ukupno trošak',
    putovanje: 'Putovanje',
    vrsta: 'Vrsta',
    utroseniDelovi: 'Utrošeni delovi',
    nazivDela: 'Naziv dela',
    cena: 'Cena',
    nabavnaCena: 'Nabavna cena',
    troskovi: 'Troškovi',
    iznosTroska: 'Iznos troška',
    opis: 'Opis',
    stavkePustanja: 'Stavke puštanja u rad',
    stavka: 'Stavka',
    cekirano: 'Čekirano',
    dnevnikTeren: 'Dnevnik - izveštaj sa terena',
    dnevnikBazaZnanja: 'Dnevnik - baza znanja',
    izvrsenaRadnja: 'Izvršena radnja',
    beleske: 'Beleške',
    beleska: 'Beleška',
    rekapitulacija: 'Rekapitulacija',
    dodatnaNapomena: 'Dodatna napomena',
    mejlNaslov: (dokument, broj) => `${dokument} ${broj} - izveštaj`,
    mejlTekst: (dokument, broj) =>
      `Poštovani,\n\nU prilogu Vam dostavljamo izveštaj za ${dokument.toLowerCase()} ${broj}.\n\nSrdačan pozdrav,\nINMOLD CUSTOMER SERVICE TEAM`,
  },
  ENG: {
    lokal: 'en-GB',
    da: 'YES',
    ne: 'NO',
    radniNalog: 'Work order',
    pustanjeURad: 'Commissioning',
    datumIzvestaja: 'Report date',
    strana: 'Page',
    nemaPodataka: 'No data.',
    ukupno: 'Total',
    brojNaloga: 'Order number',
    datum: 'Date',
    status: 'Status',
    kupac: 'Customer',
    adresa: 'Address',
    robotAlat: 'Robot/Mold',
    serijskiBroj: 'Serial number',
    podprojekat: 'Subproject',
    brojZahteva: 'Request number',
    nazivZahteva: 'Request title',
    datumZavrsetka: 'Completion date',
    zavrsen: 'Completed',
    naplacujeSe: 'Billable',
    teren: 'Field work',
    obuka: 'Training',
    opisProblema: 'Problem description',
    opisRadova: 'Work description',
    napomena: 'Note',
    dodeljeniZaposleni: 'Assigned employees',
    zaposleni: 'Employee',
    komisija: 'Commission',
    izvrseneUsluge: 'Services performed',
    nazivUsluge: 'Service',
    jm: 'UoM',
    kolicina: 'Quantity',
    praznik: 'Holiday',
    brutoCenaPrekovremeno: 'Gross overtime price',
    brutoCenaZaposlenog: 'Employee gross price',
    cenaPremaKlijentu: 'Price to customer',
    ukupnoTrosak: 'Total cost',
    putovanje: 'Travel',
    vrsta: 'Type',
    utroseniDelovi: 'Parts used',
    nazivDela: 'Part name',
    cena: 'Price',
    nabavnaCena: 'Purchase price',
    troskovi: 'Expenses',
    iznosTroska: 'Expense amount',
    opis: 'Description',
    stavkePustanja: 'Commissioning items',
    stavka: 'Item',
    cekirano: 'Checked',
    dnevnikTeren: 'Log - field report',
    dnevnikBazaZnanja: 'Log - knowledge base',
    izvrsenaRadnja: 'Action performed',
    beleske: 'Notes',
    beleska: 'Note',
    rekapitulacija: 'Summary',
    dodatnaNapomena: 'Additional note',
    mejlNaslov: (dokument, broj) => `${dokument} ${broj} - report`,
    mejlTekst: (dokument, broj) =>
      `Dear Customer,\n\nAttached is the report for ${dokument.toLowerCase()} ${broj}.\n\nBest regards,\nINMOLD CUSTOMER SERVICE TEAM`,
  },
};

let fontoviPromise = null;
let logoPromise = null;

const arrayBufferToBase64 = (buffer) => {
  const bytes = new Uint8Array(buffer);
  const chunk = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  return window.btoa(binary);
};

// Podrazumevani jsPDF font nema č, ć, š, ž, đ
export const ucitajFontove = () => {
  if (!fontoviPromise) {
    fontoviPromise = Promise.all(
      ['Roboto-Regular.ttf', 'Roboto-Medium.ttf'].map(async (naziv) => {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/fonts/${naziv}`,
        );
        if (!response.ok) throw new Error(`Font ${naziv} nije pronađen.`);
        return arrayBufferToBase64(await response.arrayBuffer());
      }),
    )
      .then(([regular, bold]) => ({ regular, bold }))
      .catch((error) => {
        fontoviPromise = null;
        throw error;
      });
  }
  return fontoviPromise;
};

export const ucitajLogo = () => {
  if (!logoPromise) {
    logoPromise = fetch(`${process.env.PUBLIC_URL}/images/inmold-logo.png`)
      .then(async (response) =>
        response.ok ? arrayBufferToBase64(await response.arrayBuffer()) : null,
      )
      .catch((error) => {
        console.error(error);
        logoPromise = null;
        return null;
      });
  }
  return logoPromise;
};

export const pripremiResurse = () =>
  Promise.all([ucitajFontove(), ucitajLogo()]).catch(console.error);

const formatDatum = (vrednost) => (vrednost ? formatDateFromDB(vrednost) : '');
const tekst = (vrednost) =>
  vrednost === null || vrednost === undefined ? '' : String(vrednost).trim();
const iznos = (kolicina, cena) => Number(kolicina || 0) * Number(cena || 0);
const sumiraj = (redovi, getVrednost) =>
  redovi.reduce((acc, red) => acc + getVrednost(red), 0);

const proveriPrelom = (doc, stanje, potrebnaVisina) => {
  const visinaStrane = doc.internal.pageSize.getHeight();
  if (stanje.y + potrebnaVisina > visinaStrane - 18) {
    doc.addPage();
    stanje.y = 20;
  }
};

const zajednickiStilovi = {
  theme: 'grid',
  margin: { left: MARGINA, right: MARGINA, top: 20, bottom: 18 },
  styles: {
    font: FONT,
    fontSize: 8,
    cellPadding: 1.8,
    overflow: 'linebreak',
    lineColor: BOJE.linija,
    lineWidth: 0.1,
    textColor: BOJE.tamna,
  },
  headStyles: {
    font: FONT,
    fontStyle: 'bold',
    fillColor: BOJE.tamna,
    textColor: 255,
  },
  footStyles: {
    font: FONT,
    fontStyle: 'bold',
    fillColor: BOJE.narandzastaSvetla,
    textColor: BOJE.narandzastaTamna,
  },
  alternateRowStyles: { fillColor: BOJE.pozadina },
};

const obojiDaNe = (p) => (data) => {
  if (data.section !== 'body') return;
  if (data.cell.raw === p.da) data.cell.styles.textColor = BOJE.zelena;
  if (data.cell.raw === p.ne) data.cell.styles.textColor = BOJE.crvena;
};

const dodajNaslov = (doc, stanje, naslov, potrebnaVisina = 20) => {
  proveriPrelom(doc, stanje, potrebnaVisina);
  doc.setFillColor(...BOJE.narandzasta);
  doc.rect(MARGINA, stanje.y - 4.2, 1.6, 5.6, 'F');
  doc.setFont(FONT, 'bold');
  doc.setFontSize(11);
  doc.setTextColor(...BOJE.tamna);
  doc.text(naslov, MARGINA + 3.6, stanje.y);
  doc.setTextColor(0);
  stanje.y += 3;
};

const dodajKartice = (doc, stanje, kartice) => {
  const sirina = 80;
  const visina = 18;
  proveriPrelom(doc, stanje, visina + 4);
  kartice.forEach(({ naslov, vrednost, boja }, index) => {
    const x = MARGINA + index * (sirina + 6);
    doc.setFillColor(...BOJE.pozadina);
    doc.roundedRect(x, stanje.y, sirina, visina, 2, 2, 'F');
    doc.setFillColor(...boja);
    doc.rect(x, stanje.y, 1.6, visina, 'F');
    doc.setFont(FONT, 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...BOJE.siva);
    doc.text(naslov.toUpperCase(), x + 5, stanje.y + 6);
    doc.setFont(FONT, 'bold');
    doc.setFontSize(15);
    doc.setTextColor(...boja);
    doc.text(vrednost, x + 5, stanje.y + 14);
  });
  doc.setTextColor(0);
  stanje.y += visina + 8;
};

const dodajSekciju = (doc, stanje, p, { naslov, kolone, redovi }) => {
  const vidljive = kolone.filter((kolona) => kolona.show !== false);
  const imaZbir = vidljive.some((kolona) => kolona.zbir);
  // Kratka tabela ne sme da se prelomi na dve strane
  dodajNaslov(doc, stanje, naslov, Math.min(14 + (redovi.length + 2) * 7, 80));

  if (!redovi.length) {
    doc.setFont(FONT, 'normal');
    doc.setFontSize(9);
    doc.setTextColor(...BOJE.siva);
    doc.text(p.nemaPodataka, MARGINA + 3.6, stanje.y + 4);
    doc.setTextColor(0);
    stanje.y += 12;
    return;
  }

  autoTable(doc, {
    ...zajednickiStilovi,
    startY: stanje.y,
    head: [vidljive.map((kolona) => kolona.header)],
    body: redovi.map((red) => vidljive.map((kolona) => kolona.value(red))),
    foot: imaZbir
      ? [
          vidljive.map((kolona, index) => {
            if (kolona.zbir) {
              return {
                content: p.formatBroj(sumiraj(redovi, kolona.zbir)),
                styles: {
                  halign: 'right',
                  textColor: kolona.boja || BOJE.narandzastaTamna,
                },
              };
            }
            return index === 0 ? p.ukupno : '';
          }),
        ]
      : undefined,
    showFoot: 'lastPage',
    columnStyles: vidljive.reduce(
      (acc, kolona, index) => ({
        ...acc,
        [index]: {
          ...(kolona.align ? { halign: kolona.align } : {}),
          ...(kolona.boja ? { textColor: kolona.boja } : {}),
        },
      }),
      {},
    ),
    didParseCell: obojiDaNe(p),
  });
  stanje.y = doc.lastAutoTable.finalY + 8;
};

const dodajZaglavlje = (doc, stanje, p, polja, dugackaPolja) => {
  const redovi = [];
  for (let i = 0; i < polja.length; i += 2) {
    const [labela1, vrednost1] = polja[i];
    const [labela2, vrednost2] = polja[i + 1] || ['', ''];
    redovi.push([labela1, tekst(vrednost1), labela2, tekst(vrednost2)]);
  }
  dugackaPolja
    .filter(([, vrednost]) => tekst(vrednost))
    .forEach(([labela, vrednost]) =>
      redovi.push([labela, { content: tekst(vrednost), colSpan: 3 }]),
    );

  const stilLabele = {
    font: FONT,
    fontStyle: 'bold',
    cellWidth: 40,
    fillColor: BOJE.narandzastaSvetla,
    textColor: BOJE.narandzastaTamna,
  };
  autoTable(doc, {
    ...zajednickiStilovi,
    startY: stanje.y,
    body: redovi,
    styles: { ...zajednickiStilovi.styles, fontSize: 9 },
    alternateRowStyles: {},
    columnStyles: { 0: stilLabele, 2: stilLabele },
    didParseCell: obojiDaNe(p),
  });
  stanje.y = doc.lastAutoTable.finalY + 10;
};

const dodajPodnozje = (doc, p, naslov) => {
  const sirina = doc.internal.pageSize.getWidth();
  const visina = doc.internal.pageSize.getHeight();
  const brojStrana = doc.getNumberOfPages();
  for (let i = 1; i <= brojStrana; i += 1) {
    doc.setPage(i);
    doc.setDrawColor(...BOJE.narandzasta);
    doc.setLineWidth(0.3);
    doc.line(MARGINA, visina - 12, sirina - MARGINA, visina - 12);
    doc.setFont(FONT, 'normal');
    doc.setFontSize(8);
    doc.setTextColor(...BOJE.siva);
    doc.text(naslov, MARGINA, visina - 8);
    doc.text(`${p.strana} ${i} / ${brojStrana}`, sirina - MARGINA, visina - 8, {
      align: 'right',
    });
    doc.setTextColor(0);
  }
};

const dodajNapomenu = (doc, stanje, p, napomena) => {
  dodajNaslov(doc, stanje, p.dodatnaNapomena, 30);
  autoTable(doc, {
    ...zajednickiStilovi,
    startY: stanje.y,
    body: [[tekst(napomena)]],
    styles: { ...zajednickiStilovi.styles, fontSize: 9, cellPadding: 3 },
    alternateRowStyles: {},
  });
  stanje.y = doc.lastAutoTable.finalY + 8;
};

export const VRSTA = {
  TEKST: 'tekst',
  BROJ: 'broj',
  IZNOS: 'iznos',
  DA_NE: 'daNe',
  DATUM: 'datum',
  TROSAK: 'trosak',
};
const CENE = { INTERNE: 'interne', KLIJENT: 'klijent' };

const period = (od, doDatuma) =>
  [formatDatum(od), formatDatum(doDatuma)].filter(Boolean).join(' - ');

const POLJA_ZAGLAVLJA = {
  [TIP_IZVESTAJA.RN]: [
    { kljuc: 'ceoBrDok', labela: 'brojNaloga' },
    { kljuc: 'datum', labela: 'datum', vrsta: VRSTA.DATUM },
    {
      kljuc: 'status',
      labela: 'status',
      vrednost: (z) => z.statusDokumenta || z.status,
    },
    { kljuc: 'nazivKupca', labela: 'kupac' },
    { kljuc: 'nazivMasine', labela: 'robotAlat' },
    { kljuc: 'nazivPodProjekta', labela: 'podprojekat' },
    {
      kljuc: 'brojZahteva',
      labela: 'brojZahteva',
      vrednost: (z) => z.ceoBrDokServisnogZahteva,
    },
    {
      kljuc: 'nazivZahteva',
      labela: 'nazivZahteva',
      vrednost: (z, zahtev) => zahtev?.naslov,
    },
    { kljuc: 'datumZavrsetka', labela: 'datumZavrsetka', vrsta: VRSTA.DATUM },
    { kljuc: 'zavrsen', labela: 'zavrsen', vrsta: VRSTA.DA_NE },
    { kljuc: 'naplacujeSe', labela: 'naplacujeSe', vrsta: VRSTA.DA_NE },
    { kljuc: 'teren', labela: 'teren', vrsta: VRSTA.DA_NE },
    {
      kljuc: 'opisProblema',
      labela: 'opisProblema',
      dugacko: true,
      vrednost: (z, zahtev) => z.opisProblema || zahtev?.opisProblema,
    },
    { kljuc: 'opisRadova', labela: 'opisRadova', dugacko: true },
    { kljuc: 'napomena', labela: 'napomena', dugacko: true },
  ],
  [TIP_IZVESTAJA.PUR]: [
    { kljuc: 'ceoBrDok', labela: 'brojNaloga' },
    { kljuc: 'datum', labela: 'datum', vrsta: VRSTA.DATUM },
    { kljuc: 'status', labela: 'status', vrednost: (z) => z.statusDokumenta },
    { kljuc: 'nazivKupca', labela: 'kupac' },
    { kljuc: 'adresa', labela: 'adresa' },
    { kljuc: 'nazivMasine', labela: 'robotAlat' },
    { kljuc: 'serijskiBroj', labela: 'serijskiBroj' },
    { kljuc: 'nazivPodProjekta', labela: 'podprojekat' },
    {
      kljuc: 'periodPUR',
      labela: 'pustanjeURad',
      vrednost: (z) => period(z.startDatumPUR, z.endDatumPUR),
    },
    {
      kljuc: 'periodObuke',
      labela: 'obuka',
      vrednost: (z) => period(z.startDatumObuka, z.endDatumObuka),
    },
    { kljuc: 'zavrsen', labela: 'zavrsen', vrsta: VRSTA.DA_NE },
    { kljuc: 'naplacujeSe', labela: 'naplacujeSe', vrsta: VRSTA.DA_NE },
    { kljuc: 'napomena', labela: 'napomena', dugacko: true },
  ],
};

const KOLONA_TROSKA = {
  vrsta: VRSTA.TROSAK,
  header: 'ukupnoTrosak',
  cene: CENE.INTERNE,
};
const KOLONA_KOLICINE = {
  polje: 'kolicina',
  header: 'kolicina',
  vrsta: VRSTA.BROJ,
};
const KOLONE_DNEVNIKA = [
  { polje: 'imeZaposlenog', header: 'zaposleni' },
  { polje: 'datum', header: 'datum', vrsta: VRSTA.DATUM },
  { polje: 'podprojekat', header: 'podprojekat' },
  { polje: 'izvrsenaRadnja', header: 'izvrsenaRadnja', dugacko: true },
  { polje: 'napomena', header: 'napomena', dugacko: true },
];

// trosak: [polje kolicine, polje cene] za kolonu "Ukupno trošak"
const SEKCIJE = [
  {
    id: 'zaposleni',
    naslov: 'dodeljeniZaposleni',
    kolone: [
      { polje: 'vrednost', header: 'zaposleni' },
      {
        polje: 'komisija',
        header: 'komisija',
        vrsta: VRSTA.DA_NE,
        tip: TIP_IZVESTAJA.PUR,
      },
    ],
  },
  {
    id: 'usluge',
    naslov: 'izvrseneUsluge',
    trosak: ['kolicina', 'brutoCenaZaposlenog'],
    kolone: [
      { polje: 'zaposleni', header: 'zaposleni' },
      { polje: 'nazivUsluge', header: 'nazivUsluge' },
      { polje: 'jm', header: 'jm' },
      KOLONA_KOLICINE,
      { polje: 'praznik', header: 'praznik', vrsta: VRSTA.DA_NE },
      {
        polje: 'brutoCenaZaposlenog',
        header: 'brutoCenaPrekovremeno',
        vrsta: VRSTA.IZNOS,
        cene: CENE.INTERNE,
      },
      {
        polje: 'cena',
        header: 'cenaPremaKlijentu',
        vrsta: VRSTA.IZNOS,
        cene: CENE.KLIJENT,
      },
      KOLONA_TROSKA,
      { polje: 'datum', header: 'datum', vrsta: VRSTA.DATUM },
      { polje: 'napomena', header: 'napomena', dugacko: true },
    ],
  },
  {
    id: 'transport',
    naslov: 'putovanje',
    trosak: ['kolicina', 'brutoCenaTroskovi'],
    kolone: [
      { polje: 'zaposleni', header: 'zaposleni' },
      { polje: 'nazivUsluge', header: 'vrsta' },
      { polje: 'jm', header: 'jm' },
      KOLONA_KOLICINE,
      { polje: 'praznik', header: 'praznik', vrsta: VRSTA.DA_NE },
      {
        polje: 'brutoCenaTroskovi',
        header: 'brutoCenaZaposlenog',
        vrsta: VRSTA.IZNOS,
        cene: CENE.INTERNE,
      },
      {
        polje: 'cena',
        header: 'cenaPremaKlijentu',
        vrsta: VRSTA.IZNOS,
        cene: CENE.KLIJENT,
      },
      KOLONA_TROSKA,
      { polje: 'datum', header: 'datum', vrsta: VRSTA.DATUM },
      { polje: 'napomena', header: 'napomena', dugacko: true },
    ],
  },
  {
    id: 'delovi',
    naslov: 'utroseniDelovi',
    trosak: ['kolicina', 'nabavnaCena'],
    kolone: [
      { polje: 'nazivDela', header: 'nazivDela' },
      KOLONA_KOLICINE,
      {
        polje: 'cena',
        header: 'cena',
        vrsta: VRSTA.IZNOS,
        cene: CENE.INTERNE,
      },
      {
        polje: 'nabavnaCena',
        header: 'nabavnaCena',
        vrsta: VRSTA.IZNOS,
        cene: CENE.INTERNE,
      },
      KOLONA_TROSKA,
      { polje: 'napomena', header: 'napomena', dugacko: true },
    ],
  },
  {
    id: 'troskovi',
    naslov: 'troskovi',
    trosak: ['kolicina', 'cena'],
    kolone: [
      { polje: 'nazivUsluge', header: 'vrsta' },
      { polje: 'jm', header: 'jm' },
      KOLONA_KOLICINE,
      {
        polje: 'cena',
        header: 'iznosTroska',
        vrsta: VRSTA.IZNOS,
        cene: CENE.INTERNE,
      },
      {
        polje: 'iznos',
        header: 'cenaPremaKlijentu',
        vrsta: VRSTA.IZNOS,
        cene: CENE.KLIJENT,
      },
      KOLONA_TROSKA,
      { polje: 'opis', header: 'opis', dugacko: true },
    ],
  },
  {
    id: 'opisRadova',
    naslov: 'opisRadova',
    tip: TIP_IZVESTAJA.RN,
    kolone: [
      { polje: 'zaposleni', header: 'zaposleni' },
      { polje: 'datumUnosa', header: 'datum', vrsta: VRSTA.DATUM },
      { polje: 'opisRadova', header: 'opis', dugacko: true },
    ],
  },
  {
    id: 'stavke',
    naslov: 'stavkePustanja',
    tip: TIP_IZVESTAJA.PUR,
    kolone: [
      { polje: 'proveravanaStavka', header: 'stavka' },
      { polje: 'cekirano', header: 'cekirano', vrsta: VRSTA.DA_NE },
      { polje: 'napomena', header: 'napomena', dugacko: true },
    ],
  },
  { id: 'dnevnikTeren', naslov: 'dnevnikTeren', kolone: KOLONE_DNEVNIKA },
  {
    id: 'dnevnikBazaZnanja',
    naslov: 'dnevnikBazaZnanja',
    kolone: KOLONE_DNEVNIKA,
  },
  {
    id: 'beleske',
    naslov: 'beleske',
    tip: TIP_IZVESTAJA.PUR,
    kolone: [
      { polje: 'vremeKreiranja', header: 'datum', vrsta: VRSTA.DATUM },
      { polje: 'napomena', header: 'beleska', dugacko: true },
    ],
  },
];

const zaTip = (tip) => (stavka) => !stavka.tip || stavka.tip === tip;

export const sekcijeIzvestaja = (tip) => SEKCIJE.filter(zaTip(tip));
export const poljaZaglavlja = (tip) =>
  POLJA_ZAGLAVLJA[tip] || POLJA_ZAGLAVLJA[TIP_IZVESTAJA.RN];

export const prikazCena = (izvestaj) => {
  const interne = Boolean(izvestaj.dozvoljeneCene && izvestaj.prikaziCene);
  return {
    [CENE.INTERNE]: interne,
    [CENE.KLIJENT]: interne && Boolean(izvestaj.zaglavlje.naplacujeSe),
  };
};

export const vidljiveKoloneZa = (sekcija, tip, cene) =>
  sekcija.kolone
    .filter(zaTip(tip))
    .filter((kolona) => !kolona.cene || cene[kolona.cene]);

export const vidljiveKolone = (sekcija, izvestaj) =>
  vidljiveKoloneZa(sekcija, izvestaj.tip, prikazCena(izvestaj));

export const trosakReda = (sekcija, red) =>
  sekcija.trosak ? iznos(red[sekcija.trosak[0]], red[sekcija.trosak[1]]) : 0;

export const rekapitulacijaIzvestaja = (izvestaj) =>
  sekcijeIzvestaja(izvestaj.tip)
    .filter(
      (sekcija) => sekcija.trosak && izvestaj.sekcije[sekcija.id]?.ukljuceno,
    )
    .map((sekcija) => ({
      id: sekcija.id,
      naslov: sekcija.naslov,
      trosak: sumiraj(izvestaj.sekcije[sekcija.id].redovi, (red) =>
        trosakReda(sekcija, red),
      ),
    }));

const pripremiVrednost = (vrsta, vrednost) => {
  if (vrsta === VRSTA.DA_NE) return Boolean(vrednost);
  if (vrsta === VRSTA.DATUM) return formatDatum(vrednost);
  if (vrsta === VRSTA.BROJ || vrsta === VRSTA.IZNOS) {
    return vrednost === null || vrednost === undefined || vrednost === ''
      ? ''
      : Number(vrednost);
  }
  return tekst(vrednost);
};

let brojacRedova = 0;
export const noviRed = (sekcija, izvor = {}) => {
  brojacRedova += 1;
  return sekcija.kolone
    .filter((kolona) => kolona.polje)
    .reduce(
      (red, kolona) => ({
        ...red,
        [kolona.polje]: pripremiVrednost(kolona.vrsta, izvor[kolona.polje]),
      }),
      { kljucReda: `red-${brojacRedova}` },
    );
};

// Model izveštaja: sve što ide u PDF i što korisnik može da izmeni pre slanja
export const napraviIzvestaj = ({ tip, podaci, dozvoljeneCene }) => {
  const { zaglavlje, zahtev } = podaci;
  return {
    tip,
    dozvoljeneCene: Boolean(dozvoljeneCene),
    prikaziCene: Boolean(dozvoljeneCene),
    prikaziRekapitulaciju: true,
    dodatnaNapomena: '',
    zaglavlje: poljaZaglavlja(tip).reduce(
      (acc, polje) => ({
        ...acc,
        [polje.kljuc]: pripremiVrednost(
          polje.vrsta,
          polje.vrednost
            ? polje.vrednost(zaglavlje, zahtev)
            : zaglavlje[polje.kljuc],
        ),
      }),
      {},
    ),
    sekcije: sekcijeIzvestaja(tip).reduce(
      (acc, sekcija) => ({
        ...acc,
        [sekcija.id]: {
          ukljuceno: true,
          redovi: (podaci[sekcija.id] || []).map((red) =>
            noviRed(sekcija, red),
          ),
        },
      }),
      {},
    ),
  };
};

export const prevodIzvestaja = (jezik) => {
  const prevod = PREVODI[jezik] || PREVODI.SRB;
  return {
    ...prevod,
    daNe: (vrednost) => (vrednost ? prevod.da : prevod.ne),
    formatBroj: (vrednost) =>
      Number(vrednost || 0).toLocaleString(prevod.lokal, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  };
};

export const podrazumevaniMejl = (tip, jezik, ceoBrDok) => {
  const p = prevodIzvestaja(jezik);
  const dokument = tip === TIP_IZVESTAJA.PUR ? p.pustanjeURad : p.radniNalog;
  return {
    naslov: p.mejlNaslov(dokument, tekst(ceoBrDok)),
    tekst: p.mejlTekst(dokument, tekst(ceoBrDok)),
  };
};

const prikaziVrednost = (p, vrsta, vrednost) => {
  if (vrsta === VRSTA.DA_NE) return p.daNe(vrednost);
  if (vrsta === VRSTA.IZNOS) return p.formatBroj(vrednost);
  return tekst(vrednost);
};

const kolonaUkupnogTroska = (p, trosak) => ({
  header: p.ukupnoTrosak,
  value: (r) => p.formatBroj(trosak(r)),
  zbir: trosak,
  align: 'right',
  boja: BOJE.crvena,
});

const pdfKolona = (p, sekcija, kolona) => {
  if (kolona.vrsta === VRSTA.TROSAK) {
    return kolonaUkupnogTroska(p, (r) => trosakReda(sekcija, r));
  }
  const desno = kolona.vrsta === VRSTA.BROJ || kolona.vrsta === VRSTA.IZNOS;
  return {
    header: p[kolona.header],
    value: (r) => prikaziVrednost(p, kolona.vrsta, r[kolona.polje]),
    align: desno ? 'right' : undefined,
  };
};

export const generisiIzvestajPDF = async ({
  izvestaj,
  jezik = JEZIK_IZVESTAJA.SRB,
}) => {
  const p = prevodIzvestaja(jezik);
  const { tip, zaglavlje } = izvestaj;
  const jePUR = tip === TIP_IZVESTAJA.PUR;
  const prikaziCene = prikazCena(izvestaj)[CENE.INTERNE];
  const naslov = `${jePUR ? p.pustanjeURad : p.radniNalog} ${tekst(
    zaglavlje.ceoBrDok,
  )}`;

  const [{ regular, bold }, logo] = await Promise.all([
    ucitajFontove(),
    ucitajLogo(),
  ]);
  const doc = new JsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  doc.addFileToVFS('Roboto-Regular.ttf', regular);
  doc.addFont('Roboto-Regular.ttf', FONT, 'normal');
  doc.addFileToVFS('Roboto-Medium.ttf', bold);
  doc.addFont('Roboto-Medium.ttf', FONT, 'bold');

  const stanje = { y: 18 };
  if (logo) {
    doc.addImage(
      logo,
      'PNG',
      MARGINA,
      8,
      LOGO_SIRINA,
      LOGO_VISINA,
      'logo',
      'FAST',
    );
    stanje.y = 8 + LOGO_VISINA + 9;
  }
  const sirinaStrane = doc.internal.pageSize.getWidth();
  const tipNaslova = `${(jePUR
    ? p.pustanjeURad
    : p.radniNalog
  ).toUpperCase()} `;
  doc.setFont(FONT, 'bold');
  doc.setFontSize(18);
  doc.setTextColor(...BOJE.tamna);
  doc.text(tipNaslova, MARGINA, stanje.y);
  doc.setTextColor(...BOJE.narandzasta);
  doc.text(
    tekst(zaglavlje.ceoBrDok),
    MARGINA + doc.getTextWidth(tipNaslova),
    stanje.y,
  );
  doc.setFont(FONT, 'normal');
  doc.setFontSize(9);
  doc.setTextColor(...BOJE.siva);
  doc.text(
    `${p.datumIzvestaja}: ${formatDatum(new Date())}`,
    sirinaStrane - MARGINA,
    stanje.y,
    { align: 'right' },
  );
  doc.setTextColor(0);
  doc.setDrawColor(...BOJE.narandzasta);
  doc.setLineWidth(0.8);
  doc.line(MARGINA, stanje.y + 3, sirinaStrane - MARGINA, stanje.y + 3);
  stanje.y += 9;

  const polja = poljaZaglavlja(tip).map((polje) => ({
    ...polje,
    par: [
      p[polje.labela],
      prikaziVrednost(p, polje.vrsta, zaglavlje[polje.kljuc]),
    ],
  }));
  dodajZaglavlje(
    doc,
    stanje,
    p,
    polja.filter((polje) => !polje.dugacko).map((polje) => polje.par),
    polja.filter((polje) => polje.dugacko).map((polje) => polje.par),
  );

  const rekapitulacija = rekapitulacijaIzvestaja(izvestaj).map((stavka) => ({
    naziv: p[stavka.naslov],
    trosak: stavka.trosak,
  }));
  if (prikaziCene) {
    dodajKartice(doc, stanje, [
      {
        naslov: p.ukupnoTrosak,
        vrednost: p.formatBroj(sumiraj(rekapitulacija, (r) => r.trosak)),
        boja: BOJE.crvena,
      },
    ]);
  }

  sekcijeIzvestaja(tip)
    .filter((sekcija) => izvestaj.sekcije[sekcija.id]?.ukljuceno)
    .forEach((sekcija) =>
      dodajSekciju(doc, stanje, p, {
        naslov: p[sekcija.naslov],
        redovi: izvestaj.sekcije[sekcija.id].redovi,
        kolone: vidljiveKolone(sekcija, izvestaj).map((kolona) =>
          pdfKolona(p, sekcija, kolona),
        ),
      }),
    );

  if (prikaziCene && izvestaj.prikaziRekapitulaciju && rekapitulacija.length) {
    dodajSekciju(doc, stanje, p, {
      naslov: p.rekapitulacija,
      redovi: rekapitulacija,
      kolone: [
        { header: p.stavka, value: (r) => r.naziv },
        kolonaUkupnogTroska(p, (r) => r.trosak),
      ],
    });
  }

  if (tekst(izvestaj.dodatnaNapomena)) {
    dodajNapomenu(doc, stanje, p, izvestaj.dodatnaNapomena);
  }

  dodajPodnozje(doc, p, naslov);
  const nazivFajla = `${tekst(zaglavlje.ceoBrDok) || 'izvestaj'}${
    jezik === JEZIK_IZVESTAJA.ENG ? '_ENG' : ''
  }.pdf`;
  return { doc, nazivFajla };
};
